import * as R from "ramda";
import { connect } from "react-redux";
import React, { useState } from "react";
import { BackTop, Divider, Tabs } from "antd";

import {
  VideoResourcePage,
  TreeNodeTextToValueMap,
} from "./tab-pages/video-resource-page";
import LiveList from "@/components/Video/List";
import Document from "@/components/Document/List";
import { useOrderDetail } from "./hooks/use-order-detail";
import { useTagList } from "./widgets/resource-tag-modal";
import { VideoTemplate } from "./tab-pages/video-template";
import { ViewMobileClip } from "./widgets/view-mobile-clip";
import { VisitorVideoGenerate } from "./widgets/visitor-video";
import { AutoUploadVideoHelperRxjs } from "./widgets/file-upload-helper";
import { MainContainer } from "@/components/MainContainer/main-container";
import { DropdownSelectUploadType } from "./widgets/dropdown-select-upload-type";

export const LabelNameOfResource = "视频创作素材";
export const LabelOfTemplate = "视频合成模板";
export const LabelOfTemplateJob = "合成任务";

export default connect((state) => ({ ...state }))((props) => {
  const orderId = R.pathOr("", ["match", "params", "orderid"], props) * 1;
  const orderDetail = useOrderDetail(orderId);
  const [tagRefreshKey, setTagRefreshKey] = useState(0);
  const availableTags = useTagList(orderId, tagRefreshKey);

  const [selectedType, setSelectedType] = useState("");
  const isSelectAllType = R.equals(
    TreeNodeTextToValueMap["全部类型"],
    selectedType
  );
  const [resetIndex, setResetIndex] = useState(0);

  return (
    <MainContainer>
      {({ height }) => {
        return (
          <div style={{ height }}>
            <div className="flex-y-center">
              <div style={{ fontSize: 16 }}>
                媒体资源 | {R.pathOr("--", ["name"])(orderDetail)}
              </div>
              <div className="ml-auto position-relative">
                <div
                  className="position-relative flex-y-center"
                  style={{
                    top: 10,
                  }}
                >
                  <VisitorVideoGenerate {...props} />
                  <div className="mr20" />
                  <ViewMobileClip {...props} />
                  <div className="mr20" />
                  <DropdownSelectUploadType
                    {...props}
                    selectedType={selectedType}
                    tagList={availableTags}
                    afterDone={() => {
                      if (isSelectAllType) {
                        setResetIndex(R.inc);
                      }
                    }}
                  />
                  <div className="mr20" />
                  <AutoUploadVideoHelperRxjs
                    tagList={availableTags}
                    type=""
                    orderId={orderId}
                    {...props}
                  />
                </div>
              </div>
            </div>
            <Divider />
            <div>
              <Tabs defaultActiveKey="2">
                <Tabs.TabPane tab="直播视频" key="1">
                  <LiveList {...props} />
                  <div
                    style={{ minHeight: 50 }}
                    key="这是一个空隙,防止页面过高,底部没有空间"
                  ></div>
                </Tabs.TabPane>
                <Tabs.TabPane tab={LabelNameOfResource} key="2">
                  <VideoResourcePage
                    setSelectedType={setSelectedType}
                    height={height}
                    {...props}
                    availableTags={availableTags}
                    tagList={availableTags}
                    refreshTagList={() => {
                      setTagRefreshKey(R.inc);
                    }}
                    resetIndex={resetIndex}
                  />
                  <BackTop
                    target={() => document.querySelector("#mainWrapper")}
                    visibilityHeight={100}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane tab={LabelOfTemplate} key="3">
                  <VideoTemplate {...props} />
                </Tabs.TabPane>
                {/*<Tabs.TabPane tab={LabelOfTemplateJob} key="4">
                  <VideoTemplateJob
                    {...props}
                    availableTags={availableTags}
                    tagList={availableTags}
                  />
                </Tabs.TabPane>*/}
                {/*<Tabs.TabPane tab="视频合成草稿" key="5">
                <ProjectList {...props} />
                </Tabs.TabPane>*/}
                <Tabs.TabPane tab="活动文件" key="6">
                  <Document {...props} />
                </Tabs.TabPane>
              </Tabs>
            </div>
          </div>
        );
      }}
    </MainContainer>
  );
});


// WEBPACK FOOTER //
// ./src/containers/Video/index.js